var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZ3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.59375,
    y: 3.74516,
    width: 15,
    height: 10.7848,
    rx: 2,
    fill: "#2469EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9063 4.02905V2.03255C11.9063 1.48026 11.4586 1.03255 10.9063 1.03255H5.28125C4.72897 1.03255 4.28125 1.48026 4.28125 2.03255V4.02905",
    stroke: "#2469EF",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.8125 8.5625L6 8.5625",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09375 7.48828L8.09375 9.63672",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.5625H15.4375",
    stroke: "white",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZ3);
export default __webpack_public_path__ + "static/media/z3.2f7cf2c9fff9e486bad45ffeb8172f3c.svg";
export { ForwardRef as ReactComponent };